<template>
  <form id="verify-form" class="mt-5" @submit.prevent="submitForm">
    <div class="auth-form-container">
      <div class="">
        <div class="row verify_gap">
          <div class="block-input">
            <h3 class="verify-title">Please check your email</h3>
            <input
              type="text"
              class="form-control form-focus"
              v-model="verificationCode"
              placeholder="Enter verify code"
            />
          </div>
          <div class="col-12 py-2">
            <ButtonWithLoading
              class="w-100"
              title="Send"
              :isLoading="isLoading"
              type="submit"
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import store from "@/vuex/store.js";
import ButtonWithLoading from "../ButtonWithLoading.vue";
export default {
  name: "VerifyUser",
  components: {
    ButtonWithLoading,
  },

  data() {
    return {
      verificationCode: "",
    };
  },

  methods: {
    submitForm() {
      if (!this.verificationCode.trim()) {
      return;
    }
      store.dispatch("sendVerify", { verificationCode: this.verificationCode });
    },
  },
  computed: {
    isLoading() {
      return store.state.auth.isLoading;
    },
  },
};
</script>

<style scoped lang="scss">
.verify-title {
  text-align: center;
}
.form-focus:focus{
  border-color: rgb(0, 110, 255) !important;
  box-shadow: 0 0 5px rgba(0, 110, 255, 0.5) !important;
}
.verify_gap{
  gap: 26px;
}
</style>
